export enum RegistrationSalutation {
  Mr = "Mr.",
  Ms = "Ms.",
  Mx = "Mx.",
}
